import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21df621f&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=21df621f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21df621f",
  null
  
)

export default component.exports